import { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';

import { ErrorBoundary } from '@webapp/common/components/error-boundary';
import { Loader } from '@webapp/common/components/loader';
import { MetrikaHits } from '@webapp/common/components/metrika-hits';
import { lazy } from '@webapp/common/lib/lazy';

import { PublicResults } from './components';
import { PublicResultsRoutes } from './results-routes';

const NotFoundPage = lazy(() => import('@webapp/common/components/not-found-page'));

export const App: FC = () => (
    <ErrorBoundary>
        <MetrikaHits />
        <Suspense fallback={<Loader />}>
            <Switch>
                <Route component={PublicResults} path={PublicResultsRoutes.results.link} />
                <Route component={NotFoundPage} />
            </Switch>
        </Suspense>
    </ErrorBoundary>
);
